/*
 * Wraps SATComponent.prototype.renderVals to add a "See more" toggle to the
 * product detail modal's long-form paragraph (snippets/sat-overlays.liquid's
 * {{ detail.detail }} block) — some listings run to a genuinely long single
 * paragraph (materials, sizing notes, care instructions, all run together),
 * and showing the whole thing by default turned the modal into a wall of
 * text. Collapsed to a short preview by default; a "See more" line expands
 * it in place, "See less" collapses it back.
 *
 * Tracks expanded state with two fields, the same pattern as
 * assets/sat-detail-gallery-patch.js's photo index: `detailMoreOpen` alone
 * would stay expanded across opening a *different* product's detail (browsing
 * "From The Same Department" without it resetting), showing that new
 * product's long text pre-expanded even though the visitor never asked for
 * it there. `detailMoreFor` records which product id the expansion was for;
 * a mismatch (a new product opened) collapses automatically.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var PREVIEW_LEN = 220;

  // Cuts at the last whole word inside the limit rather than mid-word, so
  // the collapsed preview never ends on a fragment.
  function truncate(text, len) {
    if (text.length <= len) return text;
    var cut = text.slice(0, len);
    var lastSpace = cut.lastIndexOf(' ');
    if (lastSpace > len * 0.6) cut = cut.slice(0, lastSpace);
    return cut.replace(/[,;:.\s]+$/, '') + '…';
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var s = this.state;

    if (!out.detail) {
      out.detailMoreShow = 'none';
      return out;
    }

    var fullText = out.detail.detail || '';
    var isLong = fullText.length > PREVIEW_LEN;
    var detailId = out.detail.id;
    var isOpen = s.detailMoreFor === detailId && !!s.detailMoreOpen;

    out.detail = Object.assign({}, out.detail, {
      detail: (isLong && !isOpen) ? truncate(fullText, PREVIEW_LEN) : fullText
    });
    out.detailMoreShow = isLong ? 'inline' : 'none';
    out.detailMoreLabel = isOpen ? 'See less' : 'See more';
    out.toggleDetailMore = function () {
      self.setState({ detailMoreFor: detailId, detailMoreOpen: !isOpen });
    };

    return out;
  };
})();
